// New file for time-related utilities
export const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const parseGameDateTime = (dateString) => {
  try {
    if (!dateString) {
      console.warn('Missing date string:', dateString);
      return null;
    }

    let date;
    
    // Handle SQL datetime format (YYYY-MM-DD HH:mm:ss)
    if (dateString.includes(' ') && !dateString.includes('T')) {
      const [datePart, timePart] = dateString.split(' ');
      const [year, month, day] = datePart.split('-');
      const [hour, minute, second] = timePart.split(':');
      
      // Create date assuming UTC for SQL timestamps
      date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    } else {
      // Handle ISO format (YYYY-MM-DDTHH:mm:ss.sssZ)
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) {
      console.error('Invalid date created from:', dateString);
      return null;
    }

    return date;
  } catch (error) {
    console.error('Error parsing date time:', error, { dateString });
    return null;
  }
};

export const formatGameDateTime = (isoString) => {
  try {
    const dateTime = parseGameDateTime(isoString);
    if (!dateTime) {
      return {
        groupDate: 'Invalid Date',
        displayDate: 'Invalid Date',
        displayTime: 'Invalid Time',
        headerDate: 'Invalid Date'
      };
    }

    // Format for grouping (YYYY-MM-DD in local timezone)
    const groupDate = dateTime.toLocaleDateString('en-US', {
      timeZone: userTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });

    // Format for display in GameCard (e.g., "11/1")
    const displayDate = dateTime.toLocaleDateString('en-US', {
      timeZone: userTimeZone,
      month: 'numeric',
      day: 'numeric'
    });

    // Format for section headers (e.g., "Thu, 11/1")
    const headerDate = dateTime.toLocaleDateString('en-US', {
      timeZone: userTimeZone,
      weekday: 'short',
      month: 'numeric',
      day: 'numeric'
    });

    // Format time (e.g., "11:00 AM")
    const displayTime = dateTime.toLocaleTimeString('en-US', {
      timeZone: userTimeZone,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    return {
      groupDate,
      displayDate,
      displayTime,
      headerDate
    };
  } catch (error) {
    console.error('Error formatting date time:', error, { isoString });
    return {
      groupDate: 'Invalid Date',
      displayDate: 'Invalid Date',
      displayTime: 'Invalid Time',
      headerDate: 'Invalid Date'
    };
  }
};
